var map = {
	"./BBC.png": 9489,
	"./CV-2024.pdf": 8066,
	"./DANDO.png": 5213,
	"./DANDO_1.png": 4819,
	"./DANDO_2.png": 9500,
	"./DANDO_3.png": 6535,
	"./DANDO_4.png": 5113,
	"./DANDO_5.png": 3874,
	"./DANDO_6.png": 4214,
	"./DANDO_7.png": 4187,
	"./DANDO_8.png": 3731,
	"./DEONE.png": 4234,
	"./DEONE_1.png": 3565,
	"./DEONE_10.png": 5156,
	"./DEONE_11.png": 1028,
	"./DEONE_2.png": 1763,
	"./DEONE_3.png": 8784,
	"./DEONE_4.png": 4454,
	"./DEONE_5.png": 3550,
	"./DEONE_6.png": 5317,
	"./DEONE_7.png": 6233,
	"./DEONE_8.png": 3461,
	"./DEONE_9.png": 6119,
	"./GOOGLE.png": 441,
	"./INTERCAM.png": 6547,
	"./INTERCAM_1.png": 5025,
	"./INTERCAM_2.png": 113,
	"./INTERCAM_3.png": 8645,
	"./INTERCAM_4.png": 7479,
	"./KAIROS.png": 888,
	"./KAIROS_1.png": 5876,
	"./KAIROS_10.png": 44,
	"./KAIROS_11.png": 5229,
	"./KAIROS_2.png": 3847,
	"./KAIROS_3.png": 1394,
	"./KAIROS_4.png": 1005,
	"./KAIROS_5.png": 1814,
	"./KAIROS_6.png": 5936,
	"./KAIROS_7.png": 3018,
	"./KAIROS_8.png": 6208,
	"./KAIROS_9.png": 7389,
	"./MIFEL.png": 2355,
	"./MIFEL_1.png": 2127,
	"./MIFEL_2.png": 1877,
	"./MIFEL_3.png": 5175,
	"./MIFEL_4.png": 8025,
	"./MIFEL_5.png": 709,
	"./MIFEL_6.png": 5882,
	"./MIFEL_7.png": 9212,
	"./MIFEL_8.png": 3856,
	"./MIFEL_9.png": 7270,
	"./STELLA.png": 7362,
	"./WEATHER.png": 5749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;